export default __webpack_public_path__ + "static/media/result-good.83e15ba6.png";